import React from 'react';
import './SpinnerStyle.css';

interface ISpinnerProps {
  customStyle?: React.CSSProperties;
}

const Spinner: React.FC<ISpinnerProps> = ({ customStyle }) => {
  return (
    <div className="loading-wrapper" style={customStyle}>
      <div className="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
